export function formatNumberToK(num: number) {
  const formatted = num > 1000 ? (num / 1000).toFixed(1) + 'k' : `${num}`;

  return formatted.includes('.0') ? formatted.replace('.0', '') : formatted;
}
